module.exports = __webpack_public_path__ + "static/media/instructivoaf2.9d8416a2.png";